/* ============================================================
   PAKETRABATT (bundle discount) — v1
   Körs på ALLA sidor (inte bara paketsidan), eftersom kunden kan
   ändra antal i varukorgen/cart-draweren varifrån som helst på
   siten. Kollar om varukorgen innehåller minst ett komplett "set"
   av en paketprodukts OBLIGATORISKA komponenter, och slår i så
   fall på (eller av) en matchande rabattkod via /cart/update.js.

   Rabattkoder skapas separat via Admin API, en per paketprodukt,
   med koden "BNDL<produkt-id>" — se dokumentationen som hör till
   detta bygge.
   ============================================================ */
(function () {
  var BUNDLE_CODE_PREFIX = 'BNDL';

  function getBundleCode(bundleProductId) {
    return BUNDLE_CODE_PREFIX + bundleProductId;
  }

  // Grupperar cart-rader per _bundle-property och räknar ut hur många
  // kompletta set av paketets obligatoriska komponenter som ligger i cart.
  function getQualifyingBundleCodes(cart) {
    var groups = {};

    cart.items.forEach(function (item) {
      var props = item.properties || {};
      var bundleId = props._bundle;
      var requiredQty = props._bundle_qty;
      if (!bundleId || !requiredQty) return;

      if (!groups[bundleId]) groups[bundleId] = [];
      groups[bundleId].push({
        quantity: item.quantity,
        requiredQty: parseInt(requiredQty, 10) || 1,
      });
    });

    var qualifying = [];
    Object.keys(groups).forEach(function (bundleId) {
      var lines = groups[bundleId];
      if (!lines.length) return;

      var completeSets = Math.min.apply(
        null,
        lines.map(function (l) {
          return Math.floor(l.quantity / l.requiredQty);
        })
      );

      if (completeSets >= 1) {
        qualifying.push(getBundleCode(bundleId));
      }
    });

    return qualifying;
  }

  // Läser aktuell cart, räknar ut vilka paketrabatter som ska vara
  // aktiva just nu, och uppdaterar /cart/update.js om det skiljer sig
  // från vad som redan är applicerat. Rör inte koder kunden själv
  // matat in (allt som inte börjar på BNDL lämnas orört).
  async function syncBundleDiscounts() {
    try {
      var cartResponse = await fetch('/cart.js');
      var cart = await cartResponse.json();

      var qualifyingCodes = getQualifyingBundleCodes(cart);

      var currentCodes = (cart.discount_codes || []).map(function (d) {
        return d.code;
      });
      var nonBundleCodes = currentCodes.filter(function (c) {
        return c.indexOf(BUNDLE_CODE_PREFIX) !== 0;
      });
      var currentBundleCodes = currentCodes.filter(function (c) {
        return c.indexOf(BUNDLE_CODE_PREFIX) === 0;
      });

      var sameSet =
        qualifyingCodes.length === currentBundleCodes.length &&
        qualifyingCodes.every(function (c) {
          return currentBundleCodes.indexOf(c) !== -1;
        });

      if (sameSet) return false; // inget att uppdatera

      var newCodes = nonBundleCodes.concat(qualifyingCodes);

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: newCodes.join(',') }),
      });

      return true; // cart uppdaterades, chansen finns att priser ändrats
    } catch (err) {
      console.error('Paketrabatt-koll misslyckades:', err);
      return false;
    }
  }

  window.syncBundleDiscounts = syncBundleDiscounts;

  // Kör vid varje sidladdning, ifall kunden redan har ett komplett
  // paket i varukorgen (t.ex. kommer tillbaka senare, eller ändrade
  // antal på cart-sidan där denna fil normalt inte körs).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBundleDiscounts);
  } else {
    syncBundleDiscounts();
  }
})();

function initBundleConfigurator() {
  const form = document.getElementById('bundle-configurator');
  if (!form) return;

  const totalEl = document.getElementById('bundle-total-price');
  const originalEl = document.getElementById('bundle-original-price');
  const badgeEl = document.getElementById('bundle-discount-badge');
  const addBtn = document.getElementById('bundle-add-to-cart');
  const msgEl = document.getElementById('bundle-cart-message');

  const moneyFormat = form.dataset.moneyFormat || '{{amount}} kr';
  const currency = form.dataset.currency || 'SEK';
  const bundleProductId = form.dataset.productId;

  // Paketrabatt (om satt via metafältet bundle.discount). Värdet är
  // detsamma som skickas till Admin API-rabatten som skapas separat.
  const bundleDiscount = (function () {
    const type = form.dataset.discountType;
    const value = parseFloat(form.dataset.discountValue);
    if (!type || isNaN(value)) return null;
    return { type: type, value: value };
  })();

function formatMoneyShopify(cents) {
  function withDelimiters(precision, thousands, decimal) {
    const value = (cents / 100).toFixed(precision);
    const parts = value.split('.');
    const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? intPart + decimal + parts[1] : intPart;
  }

  const placeholderMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
  const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';

  let formatted;
  switch (placeholder) {
    case 'amount_no_decimals':
      formatted = withDelimiters(0, ',', '.');
      break;
    case 'amount_with_comma_separator':
      formatted = withDelimiters(2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      formatted = withDelimiters(0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      formatted = withDelimiters(2, "'", '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      formatted = withDelimiters(0, ' ', ',');
      break;
    case 'amount_with_space_separator':
      formatted = withDelimiters(2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      formatted = withDelimiters(2, ' ', '.');
      break;
    case 'amount':
    default:
      formatted = withDelimiters(2, ',', '.');
      break;
  }

  return placeholderMatch ? moneyFormat.replace(placeholderMatch[0], formatted) : `${formatted} kr`;
}

  function formatMoney(cents) {
    return formatMoneyShopify(cents);
  }

  function updateTotal() {
    const selected = getSelectedVariants();

    // Rabatten (skapad i Shopify som en riktig rabattkod) gäller bara
    // de obligatoriska komponenterna — precis som villkoren för
    // rabattkoden. Valfria tillägg räknas alltid till fullt pris.
    const requiredSubtotal = selected
      .filter(v => v.required)
      .reduce((sum, v) => sum + (v.price * v.quantity), 0);
    const optionalSubtotal = selected
      .filter(v => !v.required)
      .reduce((sum, v) => sum + (v.price * v.quantity), 0);

    let savings = 0;
    if (bundleDiscount && requiredSubtotal > 0) {
      if (bundleDiscount.type === 'percentage') {
        savings = Math.round(requiredSubtotal * (bundleDiscount.value / 100));
      } else if (bundleDiscount.type === 'fixed_amount') {
        savings = Math.min(Math.round(bundleDiscount.value * 100), requiredSubtotal);
      }
    }

    const originalTotal = requiredSubtotal + optionalSubtotal;
    const total = originalTotal - savings;

    if (totalEl) {
      totalEl.textContent = formatMoneyShopify(total);
      totalEl.classList.toggle('bundle-summary__total-price--sale', savings > 0);
    }

    if (originalEl) {
      if (savings > 0) {
        originalEl.textContent = formatMoneyShopify(originalTotal);
        originalEl.style.display = '';
      } else {
        originalEl.style.display = 'none';
      }
    }

    if (badgeEl) {
      if (savings > 0) {
        const label = bundleDiscount.type === 'percentage'
          ? 'Spara ' + bundleDiscount.value + '%'
          : 'Spara ' + formatMoneyShopify(Math.round(bundleDiscount.value * 100));
        badgeEl.textContent = label;
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }
  }

  function getSelectedVariants() {
    const selected = [];

    form.querySelectorAll('input[type="radio"]:checked').forEach(input => {
      const component = input.closest('.bundle-component');
      if (!component) return;
      const isOptional = component.dataset.optional === 'true';
      if (isOptional) {
        const checkbox = component.querySelector('.bundle-component__include');
        if (!checkbox || !checkbox.checked) return;
      }
      selected.push({
        id: input.value,
        price: parseInt(input.dataset.price, 10),
        title: input.dataset.title,
        sku: input.dataset.sku,
        quantity: parseInt(input.dataset.quantity, 10) || 1,
        required: !isOptional,
      });
    });

    form.querySelectorAll('select[data-bundle-dropdown]').forEach(select => {
      const component = select.closest('.bundle-component');
      if (!component) return;
      const isOptional = component.dataset.optional === 'true';
      if (isOptional) {
        const checkbox = component.querySelector('.bundle-component__include');
        if (!checkbox || !checkbox.checked) return;
      }
      const option = select.options[select.selectedIndex];
      if (!option) return;
      selected.push({
        id: option.value,
        price: parseInt(option.dataset.price, 10),
        title: option.dataset.title,
        sku: option.dataset.sku,
        quantity: parseInt(option.dataset.quantity, 10) || 1,
        required: !isOptional,
      });
    });

    return selected;
  }

  function setLoading(loading) {
    addBtn.disabled = loading;
    addBtn.textContent = loading ? 'Lägger till…' : 'Lägg till i varukorgen';
    addBtn.style.background = loading ? '#aaa' : '#89B353';
  }

  function updateCartCount(itemCount) {
    const cartCountEls = document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count');
    cartCountEls.forEach(el => {
      el.textContent = itemCount;
      el.classList.remove('hide');
    });
  }

  function initQtyButtons() {
    document.querySelectorAll('[data-products] .js-qty__adjust').forEach(btn => {
      btn.addEventListener('click', async function() {
        const wrapper = this.closest('.js-qty__wrapper');
        const input = wrapper.querySelector('.js-qty__num');
        const key = input.dataset.id;
        const isMinus = this.classList.contains('js-qty__adjust--minus');
        let qty = parseInt(input.value, 10);

        qty = isMinus ? Math.max(0, qty - 1) : qty + 1;
        input.value = qty;

        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty }),
          });

          // Räkna om paketrabatter innan vi hämtar cart för rendering,
          // så att eventuell prisändring hinner med i det som visas.
          await window.syncBundleDiscounts();

          const cartResponse = await fetch('/cart.js');
          const cartData = await cartResponse.json();

          if (cartData.item_count === 0) {
            document.querySelector('#CartDrawer')?.classList.add('is-empty');
          }

          renderCartItems(cartData.items);
          updateCartCount(cartData.item_count);

        } catch (err) {
          console.error('Qty update error:', err);
        }
      });
    });
  }

  function renderCartItems(items) {
    const productsEl = document.querySelector('[data-products]');
    const subtotalEl = document.querySelector('[data-subtotal]');
    if (!productsEl) return;

    const drawer = document.querySelector('#CartDrawer');
    if (drawer) drawer.classList.remove('is-empty');

    const total = items.reduce((sum, item) => sum + item.final_line_price, 0);
    if (subtotalEl) subtotalEl.textContent = formatMoney(total);

    const itemsHtml = items.map(item => {
      const variantProps = Object.entries(item.properties || {})
        .filter(([k]) => !k.startsWith('_'))
        .map(([k, v]) => `<p class="cart__item-meta"><strong>${k}:</strong> ${v}</p>`)
        .join('');

      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="cart__item--variants"><span>${item.variant_title}</span></div>`
        : '';

      return `
        <div class="cart__item" data-key="${item.key}">
          <div class="cart__image" style="width:80px; flex-shrink:0; align-self:flex-start;">
            ${item.image ? `<img src="${item.image}&width=180" alt="${item.product_title}" style="width:80px; height:80px; object-fit:contain; display:block;">` : ''}
          </div>
          <div class="cart__item-details" style="min-width:0; flex:1;">
            <div class="cart__item-title">
              <a href="${item.url}" class="cart__item-name">${item.product_title}</a>
              ${variantTitle}
              ${variantProps}
            </div>
            <div class="cart__item-sub" style="flex-wrap:wrap;">
              <div>
                <div class="js-qty__wrapper">
                  <label for="cart_updates_${item.key}" class="hidden-label">Kvantitet</label>
                  <input type="text" id="cart_updates_${item.key}" name="updates[]" class="js-qty__num" value="${item.quantity}" min="0" pattern="[0-9]*" data-id="${item.key}">
                  <button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="Minska antalet varor med ett">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>
                    <span class="icon__fallback-text" aria-hidden="true">−</span>
                  </button>
                  <button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Öka antalet varor med ett">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>
                    <span class="icon__fallback-text" aria-hidden="true">+</span>
                  </button>
                </div>
                <div class="cart__remove">
                  <a href="/cart/change?id=${item.key}&quantity=0" class="text-link">Ta bort</a>
                </div>
              </div>
              <div class="cart__item-price-col text-right" style="min-width:70px;">
                <span class="cart__price">${formatMoney(item.final_price)}</span>
              </div>
            </div>
          </div>
        </div>`;
    }).join('');

    productsEl.innerHTML = `<div class="cart__items" data-count="${items.length}" data-cart-subtotal="${total}">${itemsHtml}</div>`;

    productsEl.classList.remove('appear-animation', 'appear-delay-2');
    productsEl.style.opacity = '1';
    productsEl.style.height = 'auto';
    initQtyButtons();
  }

  function openCart() {
    const cartTrigger = document.querySelector('.js-drawer-open-cart');
    if (cartTrigger) {
      cartTrigger.click();
    }
  }

  async function addToCart() {
    const selected = getSelectedVariants();
    if (!selected.length) return;

    setLoading(true);
    msgEl.textContent = '';

    const items = selected.map(v => {
      const item = {
        id: parseInt(v.id, 10),
        quantity: v.quantity,
      };
      // Endast obligatoriska komponenter taggas för paketrabatt-kollen.
      // Valfria tillägg ska aldrig räknas in i "kompletta set".
      if (v.required && bundleProductId) {
        item.properties = {
          _bundle: bundleProductId,
          _bundle_qty: String(v.quantity),
        };
      }
      return item;
    });

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Cart error');
      }

      // Kolla om det kompletta paketet nu ligger i cart och slå på
      // rabatten innan vi hämtar det som ska visas i draweren.
      await window.syncBundleDiscounts();

      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      openCart();

      await new Promise(resolve => setTimeout(resolve, 200));
      renderCartItems(cartData.items);
      updateCartCount(cartData.item_count);

      addBtn.disabled = true;
      addBtn.textContent = '✓ Tillagd i varukorgen';
      addBtn.style.background = '#aaa';
      msgEl.innerHTML = '<a href="/cart" style="color:#89B353; text-decoration:underline;">Gå till varukorgen →</a>';

    } catch (err) {
      console.error('Bundle cart error:', err);
      msgEl.textContent = err.message || 'Något gick fel. Försök igen.';
      msgEl.style.color = 'red';
      setLoading(false);
    }
  }

  // Lyssna på kryssrutor för valfria komponenter
  form.querySelectorAll('.bundle-component__include').forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      const component = this.closest('.bundle-component');
      const options = component.querySelector('.bundle-component__options, .bundle-component__dropdown-wrap');
      if (options) {
        if (this.checked) {
          options.classList.remove('bundle-component__options--disabled', 'bundle-component__dropdown-wrap--disabled');
        } else {
          options.classList.add(
            options.classList.contains('bundle-component__dropdown-wrap')
              ? 'bundle-component__dropdown-wrap--disabled'
              : 'bundle-component__options--disabled'
          );
        }
      }
      updateTotal();
    });
  });

  // Lyssna på dropdown-ändringar
  form.querySelectorAll('select[data-bundle-dropdown]').forEach(select => {
    select.addEventListener('change', updateTotal);
  });

  form.addEventListener('change', updateTotal);
  addBtn.addEventListener('click', addToCart);
  updateTotal();

  // Markera slutsålda varianter
  form.querySelectorAll('input[type="radio"]').forEach(input => {
    if (input.dataset.available === 'false') {
      input.disabled = true;
      input.closest('.bundle-component__option')?.classList.add('bundle-component__option--sold-out');
      if (input.checked) {
        const group = input.getAttribute('name');
        const nextAvailable = form.querySelector(`input[name="${group}"]:not([disabled])`);
        if (nextAvailable) nextAvailable.checked = true;
      }
    }
  });
  updateTotal();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBundleConfigurator);
} else {
  initBundleConfigurator();
}
